import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=f5f18a22&"
var script = {}
import style0 from "./FAQ.vue?vue&type=style&index=0&id=f5f18a22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports